import { render, staticRenderFns } from "./GlobalSearchSpecimens.vue?vue&type=template&id=030df47c&scoped=true"
import script from "./GlobalSearchSpecimens.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSpecimens.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchSpecimens.vue?vue&type=style&index=0&id=030df47c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030df47c",
  null
  
)

export default component.exports